<template>
  <v-container>
    <v-row>
      <v-col>
        <FieldValuePickerBase
          v-model="value.target"
          :component="component"
          :containers="containers"
          :table="table"
          :is-required="true"
          :model-only="true"
          title="Output Target"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FieldValuePickerBase from "../shared/FieldValuePickerBase.vue";

export default {
  name: "GetLocationDesigner",

  components: { FieldValuePickerBase },

  props: ["value", "component", "containers", "table"],
};
</script>
